import { render, staticRenderFns } from "./Course-Level-List.vue?vue&type=template&id=23d47e1a&scoped=true"
import script from "./Course-Level-List.vue?vue&type=script&lang=js"
export * from "./Course-Level-List.vue?vue&type=script&lang=js"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d47e1a",
  null
  
)

export default component.exports